module.exports = __webpack_public_path__ + "img/6.a0aaf782.jpg";